import {
  GET_QA,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  SHOW_MESSAGE,
  SET_SORT_BY,
  SET_ORDER_BY,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getQnA = (limit = 10) => {
  return (dispatch, getState) => {
    const state = getState().eh_qna;
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/qanda/list", {
        search: state.search,
        page: state.page,
        // all: false,
        courseId: state.courseId,
        limit,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_QA,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const addQnA = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/qanda/add", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: "QnA added successfully" });
          dispatch(getQnA());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const editQnA = (formData) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .put("/qanda/edit", formData)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: "QnA updated successfully" });
          dispatch(getQnA());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const deleteQnA = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .delete("/qanda/delete", { data: payload })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: "QnA deleted successfully" });
          dispatch(getQnA());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const featureQnA = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .put("/qanda/activeDeactiveQAndA", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: "QnA updated successfully" });
          dispatch(getQnA());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};

export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};

export const setCourseId = (courseId) => {
  return (dispatch) => {
    dispatch({ type: SET_PRODUCT_ID, payload: courseId });
  };
};
export const setOrderBy = (orderby) => {
  return (dispatch) => {
    dispatch({ type: SET_ORDER_BY, payload: orderby });
  };
};
export const setSortBy = (sortby) => {
  return (dispatch) => {
    dispatch({ type: SET_SORT_BY, payload: sortby });
  };
};
